export function formatString(s, variables) {
  // s can be undefined!
  if (!s) return s;

  variables.forEach((variable, i) => (s = s.replace(`{${i}}`, variable)));

  return s;
}
